import React from 'react';
import { Helmet } from 'react-helmet-async';

export const NoIndexSEO = ({
  title,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      {/* Prevent indexing */}
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex, nofollow" />
      {/* Prevent caching */}
      <meta http-equiv="Cache-Control" content="no-store, no-cache, must-revalidate" />
      <meta http-equiv="Pragma" content="no-cache" />
      <meta http-equiv="Expires" content="0" />
    </Helmet>
  );
}; 